import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'
import Wrapper from './views/Wrapper.vue'
import TokenService from './services/storage.service'

Vue.use( Router )

const router = new Router( {
    linkActiveClass: 'active',
    routes: [ {
            path: '/',
            name: 'Wrapper',
            component: Wrapper,
            meta: {
                toDashboard: true
            },
            children: [ {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: () =>
                        import ( './views/About.vue' ),
                    meta: {
                        title: ''
                    },
                    alias: ''
                },
                // {
                //     path: 'cglink',
                //     name: 'cglink',
                //     component: () =>
                //         import ( './views/CgLink.vue' )
                // },

                // {
                //     path: '15th-birthday',
                //     name: '15th-birthday-list',
                //     component: () =>
                //         import ( './views/Contest202115thBirthday/NNPLCompetitionList.vue' )
                // },
                // {
                //     path: '15th-birthday/:id',
                //     name: '15th-birthday-details',
                //     component: () =>
                //         import ( './views/Contest202115thBirthday/NNPLCompetitionDetal.vue' ),
                //     meta: {
                //         name: 'Usługi'
                //     }
                // },

                // {
                //     path: 'competition-on-wave',
                //     name: 'competition-on-wave-list',
                //     component: () =>
                //         import ( './views/CompetitionOnWave/NNPLCompetitionOnWaveList.vue' )
                // },
                // {
                //     path: 'competition-on-wave/:id',
                //     name: 'competition-on-wave-details',
                //     component: () =>
                //         import ( './views/CompetitionOnWave/NNPLCompetitionOnWaveDetal.vue' ),
                //     meta: {
                //         name: 'Usługi'
                //     }
                // },

                // {
                //     path: 'competition',
                //     name: 'competition-list',
                //     component: () =>
                //         import ( './views/Competition/NNPLCompetitionList.vue' )
                // },
                // {
                //     path: 'competition/:id',
                //     name: 'competition-details',
                //     component: () =>
                //         import ( './views/Competition/NNPLCompetitionDetal.vue' ),
                //     meta: {
                //         name: 'Usługi'
                //     }
                // },

                // {
                //     path: 'paradise',
                //     name: 'paradise-list',
                //     component: () =>
                //         import ( './views/Competition2021/NNPLCompetitionList.vue' )
                // },
                // {
                //     path: 'paradise/:id',
                //     name: 'paradise-details',
                //     component: () =>
                //         import ( './views/Competition2021/NNPLCompetitionDetal.vue' ),
                //     meta: {
                //         name: 'Usługi'
                //     }
                // },

                // {
                //     path: 'uslugi',
                //     name: 'services-list',
                //     component: () =>
                //         import ( './views/Services/ServicesList.vue' )
                // },
                // {
                //     path: 'uslugi/dodaj',
                //     name: 'services-add',
                //     component: () =>
                //         import ( './views/Services/ServicesForm.vue' )
                // },
                // {
                //     path: 'ustawienia/uslugi/:id',
                //     name: 'services-details',
                //     component: () =>
                //         import ( './views/Services/ServicesDetails.vue' ),
                //     meta: {
                //         name: 'Usługi'
                //     }
                // },
                // {
                //     path: 'raport-sprzedazy',
                //     name: 'sales-report',
                //     component: () =>
                //         import ( './views/SalesReport/SalesReportMain.vue' )
                // },
                // {
                //     path: 'pl/neonail/raport',
                //     name: 'plneonail-report',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLReport.vue' )
                // },
                // {
                //     path: 'pl/neonail/raports/category',
                //     name: 'plneonail-reports-category',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLReportCategory.vue' )
                // },
                // {
                //     path: 'raport-klienci',
                //     name: 'customers-report',
                //     component: () =>
                //         import ( './views/SalesReport/CustomerReportMain.vue' )
                // },

                // {
                //     path: 'pl/neonail',
                //     name: 'plneonail',
                //     component: () =>
                //         import ( './views/ShopNNPL.vue' )
                // },
                // {
                //     path: 'pl/neonail/zamowienia',
                //     name: 'plneonail-sells',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSells.vue' )
                // },
                // {
                //     path: 'pl/neonail/numery-zamowien',
                //     name: 'plneonail-number-orders',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLNumberOrders.vue' )
                // },
                // {
                //     path: 'pl/neonail/zamowienia-niewyslane',
                //     name: 'plneonail-sells-not-sent',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSellsNotSent.vue' )
                // },
                // {
                //     path: 'pl/neonail/zamowienia-uwagi',
                //     name: 'plneonail-sells-notice',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSellsNotice.vue' )
                // },
                // {
                //     path: 'pl/neonail/sprzedaz-produktu',
                //     name: 'plneonail-sell-produckt-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSellProducktStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/sprzedaz-po-kategorii',
                //     name: 'plneonail-sell-category-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSellCategoryStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/sprzedaz-promocji',
                //     name: 'plneonail-sell-promotion-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSalePromotionStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/sprzedaz-promocji-v2',
                //     name: 'plneonail-sell-promotion-statistics-v2',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSalePromotionStatisticsV2.vue' )
                // },
                // {
                //     path: 'pl/neonail/produkty',
                //     name: 'plneonail-products',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLProducts.vue' )
                // },
                // {
                //     path: '/pl/neonail/produkty/',
                //     name: 'plneonail-wrapper-editor',
                //     component: () =>
                //         import ( './views/WrapperEditor.vue' ),
                //     meta: {
                //         toDashboard: true
                //     },
                //     children: [ {
                //         path: ':id',
                //         name: 'plneonail-products-editor',
                //         component: () =>
                //             import ( './views/ShopNNPL/NNPLProductsEditor.vue' )
                //     } ]
                // },
                // {
                //     path: 'pl/neonail/produkty-do-kategorii',
                //     name: 'plneonail-products-to-category',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLProductToCategory.vue' )
                // },
                // {
                //     path: 'pl/neonail/produkty-symbol',
                //     name: 'plneonail-products-symbol',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLProductSymbol.vue' )
                // },
                // {
                //     path: 'pl/neonail/produkty-price-change',
                //     name: 'plneonail-products-price-change',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLProductPriceChange.vue' )
                // },
                // {
                //     path: 'pl/neonail/produkty-sprzedaz',
                //     name: 'plneonail-products-sell',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLProductsSell.vue' )
                // },
                // {
                //     path: 'pl/neonail/newsletter',
                //     name: 'plneonail-newsletter',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLNewsletter.vue' )
                // },
                // {
                //     path: 'pl/neonail/kody-rabatowe',
                //     name: 'plneonail-discount',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLDiscount.vue' )
                // },
                // {
                //     path: 'pl/neonail/kody-rabatowe/:id',
                //     name: 'plneonail-discount-details',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLDiscountDetails.vue' )
                // },
                // {
                //     path: 'pl/neonail/kody-rabatowe-sprzedaz',
                //     name: 'plneonail-discount-code-sell',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLDiscountCodeSell.vue' )
                // },
                // {
                //     path: 'pl/neonail/kody-rabatowe-sprzedaz2',
                //     name: 'plneonail-discount-code-sell-2',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLDiscountCodeSell2.vue' )
                // },
                // {
                //     path: 'pl/neonail/klienci',
                //     name: 'plneonail-customers',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLCustomers.vue' )
                // },
                // {
                //     path: 'pl/neonail/karty-lojalnosciowe',
                //     name: 'plneonail-loyalty-cards',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLLoyaltyCards.vue' )
                // },
                // {
                //     path: 'pl/neonail/karty-lojalnosciowe-kontrola',
                //     name: 'plneonail-loyalty-cards-control',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLLoyaltyCardsControl.vue' )
                // },
                // {
                //     path: 'pl/neonail/klient-liczba-zamowien',
                //     name: 'plneonail-customers-number-orders',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLCustomersNumberOrders.vue' )
                // },
                // {
                //     path: 'pl/neonail/newsleatter',
                //     name: 'plneonail-newsleatter',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLNewsletter.vue' )
                // },
                {
                    path: 'pl/neonail/karty-podarunkowe',
                    name: 'plneonail-gift-cards',
                    component: () =>
                        import ( './views/ShopNNPL/NNPLGiftCards.vue' )
                },
                // {
                //     path: 'pl/neonail/karty-podarunkowe/dodaj',
                //     name: 'plneonail-gift-cards-add',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLGiftCardsAdd.vue' )
                // },
                // {
                //     path: 'pl/neonail/karty-podarunkowe/uzyte',
                //     name: 'plneonail-gift-cards-used',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLGiftCardsUsed.vue' )
                // },
                // {
                //     path: 'pl/neonail/nasze-promocje',
                //     name: 'plneonail-payment-our-promotions',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLOurPromotions.vue' )
                // },
                // {
                //     path: 'pl/neonail/nasze-nowosci',
                //     name: 'plneonail-discover-our-news',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLOurNews.vue' )
                // },
                // {
                //     path: 'pl/neonail/metody-platnosci-statystyki',
                //     name: 'plneonail-payment-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLPaymentMethodsStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/bestseller',
                //     name: 'bestseller-pl',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLBestseller.vue' )
                // },
                // {
                //     path: 'pl/neonail/darmowa-dostawa-statystyka',
                //     name: 'plneonail-free-delivery-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLFreeDeliveryStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/metody-dostawy-statystyki',
                //     name: 'plneonail-delivery-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLDeliveryMethodsStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/konfigurator-zestawow',
                //     name: 'plneonail-set-configurator',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLSetConfigurator.vue' )
                // },
                // {
                //   path: 'pl/neonail/vat',
                //   name: 'NNPLVat',
                //   component: () => import( './views/ShopNNPL/NNPLVat.vue' )
                // },
                // {
                //     path: 'pl/neonail/faq',
                //     name: 'NNPLFaq',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLFaq.vue' )
                // },
                // {
                //     path: 'pl/neonail/sprzedaz-kolekcje',
                //     name: 'plneonail-collection-statistics',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLCollectionStatistics.vue' )
                // },
                // {
                //     path: 'pl/neonail/inspiracje',
                //     name: 'plneonail-inspiration',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLInspirations.vue' )
                // },
                // {
                //     path: 'pl/neonail/inspiracje/:id',
                //     name: 'plneonail-inspiration-details',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLInspirationsDetails.vue' )
                // },
                // {
                //     path: 'pl/neonail/products_sales2',
                //     name: 'plneonail-products_sales2',
                //     component: () =>
                //         import ( './views/ShopNNPL/NNPLProductsSales3.vue' )
                // },

                // {
                //     path: 'de/neonail',
                //     name: 'deneonail',
                //     component: () =>
                //         import ( './views/ShopNNDE.vue' )
                // },
                // {
                //     path: 'de/neonail/zamowienia',
                //     name: 'deneonail-sells',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDESells.vue' )
                // },
                // {
                //     path: 'de/neonail/numery-zamowien',
                //     name: 'deneonail-number-orders',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDENumberOrders.vue' )
                // },
                // {
                //     path: 'de/neonail/zamowienia-uwagi',
                //     name: 'deneonail-sells-notice',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDESellsNotice.vue' )
                // },
                // {
                //     path: 'de/neonail/bestseller',
                //     name: 'bestseller-de',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEBestseller.vue' )
                // },
                // {
                //     path: 'de/neonail/darmowa-dostawa-statystyka',
                //     name: 'deneonail-free-delivery-statistics',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEFreeDeliveryStatistics.vue' )
                // },
                // {
                //     path: 'de/neonail/sprzedaz-produktu',
                //     name: 'deneonail-sell-produckt-statistics',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDESellProducktStatistics.vue' )
                // },
                // {
                //     path: 'de/neonail/sprzedaz-po-kategorii',
                //     name: 'deneonail-sell-category-statistics',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDESellCategoryStatistics.vue' )
                // },
                // {
                //     path: 'de/neonail/produkty',
                //     name: 'deneonail-products',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEProducts.vue' )
                // },
                // {
                //     path: 'de/neonail/produkty-sprzedaz',
                //     name: 'deneonail-products-sell',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEProductsSell.vue' )
                // },
                // {
                //     path: 'de/neonail/produkty-do-kategorii',
                //     name: 'deneonail-products-to-category',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEProductToCategory.vue' )
                // },
                // {
                //     path: 'de/neonail/newsletter',
                //     name: 'deneonail-newsletter',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDENewsletter.vue' )
                // },
                // {
                //     path: 'de/neonail/klient-liczba-zamowien',
                //     name: 'deneonail-customers-number-orders',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDECustomersNumberOrders.vue' )
                // },
                // {
                //     path: 'de/neonail/kody-rabatowe',
                //     name: 'deneonail-discount',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEDiscount.vue' )
                // },
                // {
                //     path: 'de/neonail/kody-rabatowe/:id',
                //     name: 'deneonail-discount-details',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEDiscountDetails.vue' )
                // },
                // {
                //     path: 'de/neonail/kody-rabatowe-sprzedaz',
                //     name: 'deneonail-discount-code-sell',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEDiscountCodeSell.vue' )
                // },
                // {
                //     path: 'de/neonail/klienci',
                //     name: 'deneonail-customers',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDECustomers.vue' )
                // },
                // {
                //     path: 'de/neonail/newsleatter',
                //     name: 'deneonail-newsleatter',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDENewsletter.vue' )
                // },
                // {
                //     path: 'de/neonail/metody-platnosci-statystyki',
                //     name: 'deneonail-payment-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEPaymentMethodsStatistics.vue' )
                // },
                // {
                //     path: 'de/neonail/metody-dostawy-statystyki',
                //     name: 'deneonail-delivery-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopNNDE/NNDEDeliveryMethodsStatistics.vue' )
                // },
                // // {
                // //   path: 'de/neonail/vat',
                // //   name: 'NNDEVat',
                // //   component: () => import( './views/ShopNNDE/NNDEVat.vue' )
                // // },
                // {
                //     path: 'es/neonail',
                //     name: 'esneonail',
                //     component: () =>
                //         import ( './views/ShopNNES.vue' )
                // },
                // {
                //     path: 'es/neonail/zamowienia',
                //     name: 'esneonail-sells',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESSells.vue' )
                // },
                // {
                //     path: 'es/neonail/numery-zamowien',
                //     name: 'esneonail-number-orders',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESNumberOrders.vue' )
                // },
                // {
                //     path: 'es/neonail/zamowienia-uwagi',
                //     name: 'esneonail-sells-notice',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESSellsNotice.vue' )
                // },
                // {
                //     path: 'es/neonail/bestseller',
                //     name: 'bestseller-es',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESBestseller.vue' )
                // },
                // {
                //     path: 'es/neonail/darmowa-dostawa-statystyka',
                //     name: 'esneonail-free-delivery-statistics',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESFreeDeliveryStatistics.vue' )
                // },
                // {
                //     path: 'es/neonail/sprzedaz-promocji-v2',
                //     name: 'esneonail-sell-promotion-statistics-v2',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESSalePromotionStatisticsV2.vue' )
                // },
                // {
                //     path: 'es/neonail/sprzedaz-produktu',
                //     name: 'esneonail-sell-produckt-statistics',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESSellProducktStatistics.vue' )
                // },
                // {
                //     path: 'es/neonail/sprzedaz-po-kategorii',
                //     name: 'esneonail-sell-category-statistics',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESSellCategoryStatistics.vue' )
                // },
                // {
                //     path: 'es/neonail/produkty',
                //     name: 'esneonail-products',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESProducts.vue' )
                // },
                // {
                //     path: 'es/neonail/produkty-sprzedaz',
                //     name: 'esneonail-products-sell',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESProductsSell.vue' )
                // },
                // {
                //     path: 'es/neonail/produkty-do-kategorii',
                //     name: 'esneonail-products-to-category',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESProductToCategory.vue' )
                // },
                // {
                //     path: 'es/neonail/newsletter',
                //     name: 'esneonail-newsletter',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESNewsletter.vue' )
                // },
                // {
                //     path: 'es/neonail/klient-liczba-zamowien',
                //     name: 'esneonail-customers-number-orders',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESCustomersNumberOrders.vue' )
                // },
                // {
                //     path: 'es/neonail/metody-platnosci-statystyki',
                //     name: 'esneonail-payment-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESPaymentMethodsStatistics.vue' )
                // },
                // {
                //     path: 'es/neonail/metody-dostawy-statystyki',
                //     name: 'esneonail-delivery-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESDeliveryMethodsStatistics.vue' )
                // },
                // // {
                // //   path: 'es/neonail/vat',
                // //   name: 'NNESVat',
                // //   component: () => import( './views/ShopNNES/NNESVat.vue' )
                // // },
                // {
                //     path: 'es/neonail/kody-rabatowe',
                //     name: 'esneonail-discount',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESDiscount.vue' )
                // },
                // {
                //     path: 'es/neonail/kody-rabatowe/:id',
                //     name: 'esneonail-discount-details',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESDiscountDetails.vue' )
                // },
                // {
                //     path: 'es/neonail/kody-rabatowe-sprzedaz',
                //     name: 'esneonail-discount-code-sell',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESDiscountCodeSell.vue' )
                // },
                // {
                //     path: 'es/neonail/klienci',
                //     name: 'esneonail-customers',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESCustomers.vue' )
                // },
                // {
                //     path: 'es/neonail/newsleatter',
                //     name: 'esneonail-newsleatter',
                //     component: () =>
                //         import ( './views/ShopNNES/NNESNewsletter.vue' )
                // },
                // {
                //     path: 'es/neonail/reklamacje',
                //     name: 'esneonail-complaints-list',
                //     component: () =>
                //         import ( './views/ShopNNES/Complaints/List.vue' )
                // },
                // {
                //     path: 'es/neonail/reklamacje/:id',
                //     name: 'esneonail-complaints-details',
                //     component: () =>
                //         import ( './views/ShopNNES/Complaints/Details.vue' )
                // },
                // {
                //     path: 'es/neonail/reklamacje/ustawienia',
                //     name: 'esneonail-complaints-settings',
                //     component: () =>
                //         import ( './views/ShopNNES/Complaints/Settings.vue' )
                // },

                // {
                //     path: 'pl/mylaq',
                //     name: 'plmylaq',
                //     component: () =>
                //         import ( './views/ShopMQPL.vue' )
                // },
                // {
                //     path: 'pl/mylaq/zamowienia',
                //     name: 'plmylaq-sells',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLSells.vue' )
                // },
                // {
                //     path: 'pl/mylaq/zamowienia-uwagi',
                //     name: 'plmylaq-sells-notice',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLSellsNotice.vue' )
                // },
                // {
                //     path: 'pl/mylaq/sprzedaz-produktu',
                //     name: 'plmylaq-sell-produckt-statistics',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLSellProducktStatistics.vue' )
                // },
                // {
                //     path: 'pl/mylaq/sprzedaz-po-kategorii',
                //     name: 'plmylaq-sell-category-statistics',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLSellCategoryStatistics.vue' )
                // },
                // {
                //     path: 'pl/mylaq/produkty',
                //     name: 'plmylaq-products',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLProducts.vue' )
                // },
                // {
                //     path: 'pl/mylaq/newsletter',
                //     name: 'plmylaq-newsletter',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLNewsletter.vue' )
                // },
                // {
                //     path: 'pl/mylaq/kody-rabatowe',
                //     name: 'plmylaq-discount',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLDiscount.vue' )
                // },
                // {
                //     path: 'pl/mylaq/kody-rabatowe/:id',
                //     name: 'plmylaq-discount-details',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLDiscountDetails.vue' )
                // },
                // {
                //     path: 'pl/mylaq/klienci',
                //     name: 'plmylaq-customers',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLCustomers.vue' )
                // },
                // {
                //     path: 'pl/mylaq/newsleatter',
                //     name: 'plmylaq-newsleatter',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLNewsletter.vue' )
                // },
                // {
                //     path: 'pl/mylaq/metody-platnosci-statystyki',
                //     name: 'plmylaq-payment-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLPaymentMethodsStatistics.vue' )
                // },
                // {
                //     path: 'pl/mylaq/metody-dostawy-statystyki',
                //     name: 'plmylaq-delivery-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopMQPL/MQPLDeliveryMethodsStatistics.vue' )
                // },

                // {
                //     path: 'de/mylaq',
                //     name: 'demylaq',
                //     component: () =>
                //         import ( './views/ShopMQDE.vue' )
                // },
                // {
                //     path: 'de/mylaq/zamowienia',
                //     name: 'demylaq-sells',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDESells.vue' )
                // },
                // {
                //     path: 'de/mylaq/zamowienia-uwagi',
                //     name: 'demylaq-sells-notice',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDESellsNotice.vue' )
                // },
                // {
                //     path: 'de/mylaq/sprzedaz-produktu',
                //     name: 'demylaq-sell-produckt-statistics',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDESellProducktStatistics.vue' )
                // },
                // {
                //     path: 'de/mylaq/sprzedaz-po-kategorii',
                //     name: 'demylaq-sell-category-statistics',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDESellCategoryStatistics.vue' )
                // },
                // {
                //     path: 'de/mylaq/produkty',
                //     name: 'demylaq-products',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDEProducts.vue' )
                // },
                // {
                //     path: 'de/mylaq/newsletter',
                //     name: 'demylaq-newsletter',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDENewsletter.vue' )
                // },

                // {
                //     path: 'de/neonail/reklamacje',
                //     name: 'deneonail-complaints-list',
                //     component: () =>
                //         import ( './views/ShopNNDE/Complaints/List.vue' )
                // },
                // {
                //     path: 'de/neonail/reklamacje/:id',
                //     name: 'deneonail-complaints-details',
                //     component: () =>
                //         import ( './views/ShopNNDE/Complaints/Details.vue' )
                // },
                // {
                //     path: 'de/neonail/reklamacje/ustawienia',
                //     name: 'deneonail-complaints-settings',
                //     component: () =>
                //         import ( './views/ShopNNDE/Complaints/Settings.vue' )
                // },

                // {
                //     path: 'de/mylaq/kody-rabatowe',
                //     name: 'demylaq-discount',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDEDiscount.vue' )
                // },
                // {
                //     path: 'de/mylaq/kody-rabatowe/:id',
                //     name: 'demylaq-discount-details',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDEDiscountDetails.vue' )
                // },
                // {
                //     path: 'de/mylaq/klienci',
                //     name: 'demylaq-customers',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDECustomers.vue' )
                // },
                // {
                //     path: 'de/mylaq/newsleatter',
                //     name: 'demylaq-newsleatter',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDENewsletter.vue' )
                // },
                // {
                //     path: 'de/mylaq/metody-platnosci-statystyki',
                //     name: 'demylaq-payment-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDEPaymentMethodsStatistics.vue' )
                // },
                // {
                //     path: 'de/mylaq/metody-dostawy-statystyki',
                //     name: 'demylaq-delivery-methods-statistics',
                //     component: () =>
                //         import ( './views/ShopMQDE/MQDEDeliveryMethodsStatistics.vue' )
                // },
                // {
                //   path: 'de/mylaq/vat',
                //   name: 'MQDEVat',
                //   component: () => import( './views/ShopMQDE/MQDEVat.vue' )
                // },

                // {
                //     path: 'pl/expert',
                //     name: 'plexpert-list',
                //     component: () =>
                //         import ( './views/ExpertPl/Customer.vue' )
                // },
                // {
                //     path: 'pl/expert/:id',
                //     name: 'plexpert-details',
                //     component: () =>
                //         import ( './views/ExpertPl/CustomersDetails.vue' )
                // },
                // {
                //     path: 'porownywarka',
                //     name: 'comparison-list',
                //     component: () =>
                //         import ( './views/Comparison/List.vue' )
                // },
                // {
                //     path: 'porownywarka/dodaj',
                //     name: 'comparison-add',
                //     component: () =>
                //         import ( './views/Comparison/Form.vue' )
                // },
                // {
                //     path: 'porownywarka/kategorie',
                //     name: 'comparison-list',
                //     component: () =>
                //         import ( './views/Comparison/ListCategories.vue' )
                // },
                // {
                //     path: 'porownywarka/parametry',
                //     name: 'comparison-list',
                //     component: () =>
                //         import ( './views/Comparison/ListParameters.vue' )
                // },
                // {
                //     path: 'porownywarka/:id',
                //     name: 'comparison-details',
                //     component: () =>
                //         import ( './views/Comparison/Details.vue' ),
                //     meta: {
                //         name: 'Porównywarka'
                //     }
                // },

                {
                    path: 'przymierzalnia/:env/banners',
                    name: 'fitting-products',
                    component: () =>
                        import ( './views/VNFR/Banners/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/banners/:id',
                    name: 'fitting-products',
                    component: () =>
                        import ( './views/VNFR/Banners/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/produkty',
                    name: 'fitting-products',
                    component: () =>
                        import ( './views/VNFR/Products/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/produkty/dodaj',
                    name: 'fitting-product-add',
                    component: () =>
                        import ( './views/VNFR/Products/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/kolejnosc-produktow',
                    name: 'fitting-sort-products',
                    component: () =>
                        import ( './views/VNFR/ProductsSort/List.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/produkty/:id',
                    name: 'fitting-products',
                    component: () =>
                        import ( './views/VNFR/Products/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                {
                    path: 'przymierzalnia/:env/produkty/:id/:clone',
                    name: 'fitting-products',
                    component: () =>
                        import ( './views/VNFR/Products/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/produkty-w-kategori',
                    name: 'fitting-products',
                    component: () =>
                        import ( './views/VNFR/ProductsInCategories/List.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                {
                    path: 'przymierzalnia/:env/kategorie',
                    name: 'fitting-categories',
                    component: () =>
                        import ( './views/VNFR/Categories/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/kategorie/dodaj',
                    name: 'fitting-categories-add',
                    component: () =>
                        import ( './views/VNFR/Categories/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/kategorie/:id',
                    name: 'fitting-categories',
                    component: () =>
                        import ( './views/VNFR/Categories/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                {
                    path: 'przymierzalnia/:env/parametry',
                    name: 'fitting-parameters',
                    component: () =>
                        import ( './views/VNFR/Parameters/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/parametry/dodaj',
                    name: 'fitting-parameters',
                    component: () =>
                        import ( './views/VNFR/Parameters/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/parametry/:id',
                    name: 'fitting-parameters',
                    component: () =>
                        import ( './views/VNFR/Parameters/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/parametryTypy',
                    name: 'fitting-parameters-types',
                    component: () =>
                        import ( './views/VNFR/ParameterTypes/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/parametryTypy/dodaj',
                    name: 'fitting-parameters-types',
                    component: () =>
                        import ( './views/VNFR/ParameterTypes/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/parametryTypy/:id',
                    name: 'fitting-parameters-types',
                    component: () =>
                        import ( './views/VNFR/ParameterTypes/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                {
                    path: 'przymierzalnia/:env/sklepy',
                    name: 'fitting-shops',
                    component: () =>
                        import ( './views/VNFR/Shops/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/sklepy/dodaj',
                    name: 'fitting-shops',
                    component: () =>
                        import ( './views/VNFR/Shops/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/sklepy/:id',
                    name: 'fitting-shops',
                    component: () =>
                        import ( './views/VNFR/Shops/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                {
                    path: 'przymierzalnia/:env/koszyki',
                    name: 'fitting-shopping-carts',
                    component: () =>
                        import ( './views/VNFR/ShoppingCarts/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/koszyki/dodaj',
                    name: 'fitting-shopping-carts',
                    component: () =>
                        import ( './views/VNFR/ShoppingCarts/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },
                {
                    path: 'przymierzalnia/:env/koszyki/:id',
                    name: 'fitting-shopping-carts',
                    component: () =>
                        import ( './views/VNFR/ShoppingCarts/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                {
                    path: 'przymierzalnia/:env/lista-zyczen',
                    name: 'fitting-wish-list',
                    component: () =>
                        import ( './views/VNFR/WishList/List.vue' )
                },
                {
                    path: 'przymierzalnia/:env/lista-zyczen/:id',
                    name: 'fitting-wish-list',
                    component: () =>
                        import ( './views/VNFR/WishList/Details.vue' ),
                    meta: {
                        name: 'Przymierzalnia'
                    }
                },

                // {
                //     path: 'kontrola-platnosci',
                //     name: 'payment-control',
                //     component: () =>
                //         import ( './views/PaymentControl/PaymentControl.vue' )
                // },
                // {
                //     path: 'location',
                //     name: 'location',
                //     component: () =>
                //         import ( './views/Location/Location.vue' )
                // },
                // {
                //     path: 'location/add',
                //     name: 'location-add',
                //     component: () =>
                //         import ( './views/Location/LocationAdd.vue' )
                // },
                // {
                //     path: 'location/:id',
                //     name: 'location-edit',
                //     component: () =>
                //         import ( './views/Location/LocationDetails.vue' ),
                //     meta: {
                //         name: 'location',
                //         privilege: [ 1, 2, 3, 4, 8 ]
                //     }
                // },
                // {
                //     path: 'terminarz',
                //     name: 'schedule',
                //     component: () =>
                //         import ( './views/Schedule.vue' )
                // },
                // {
                //     path: 'douglas',
                //     name: 'douglas-pdt-to-excel-order',
                //     component: () =>
                //         import ( './views/Douglas/DouglasPdtToExcelOrder.vue' )
                // },
                // {
                //     path: 'douglas/de',
                //     name: 'douglas-de-pdt-to-excel-order',
                //     component: () =>
                //         import ( './views/Douglas/DouglasPdtToExcelOrderDe.vue' )
                // },
                // {
                //     path: 'douglas/pt',
                //     name: 'douglas-pt-pdt-to-excel-order',
                //     component: () =>
                //         import ( './views/Douglas/DouglasPdtToExcelOrderPt.vue' )
                // },
                // {
                //     path: 'kontigo',
                //     name: 'kontigo-pdt-to-excel-order',
                //     component: () =>
                //         import ( './views/Kontigo/KontigoPdtToExcelOrder.vue' )
                // },
                // {
                //     path: 'natura',
                //     name: 'natura-pdt-to-excel-order',
                //     component: () =>
                //         import ( './views/Natura/NaturaExcelToExcelOrder.vue' )
                // },

                // {
                //     path: 'allegro',
                //     component: () =>
                //         import ( './views/Allegro/AllegroWrapper.vue' ),
                //     children: [ {
                //             path: '',
                //             // name: 'allegro-preloader',
                //             component: () =>
                //                 import ( './views/Allegro/Preloader.vue' )
                //         },
                //         {
                //             path: 'dodaj-konto',
                //             name: 'allegro-add-account',
                //             component: () =>
                //                 import ( './views/Allegro/AddAccount.vue' )
                //         },
                //         {
                //             path: 'ustawienia',
                //             name: 'allegro-settings',
                //             component: () =>
                //                 import ( './views/Allegro/Settings.vue' )
                //         },
                //         {
                //             path: ':id',
                //             name: 'allegro-dashboard',
                //             component: () =>
                //                 import ( './views/Allegro/Dashboard.vue' )
                //         }
                //     ]
                // },

                // {
                //     path: 'empik',
                //     component: () =>
                //         import ( './views/Empik/EmpikWrapper.vue' ),
                //     children: [ {
                //             path: '',
                //             name: 'empik-offers-list',
                //             component: () =>
                //                 import ( './views/Empik/Offers/List.vue' )
                //         },
                //         {
                //             path: 'upload',
                //             name: 'empik-upload-file',
                //             component: () =>
                //                 import ( './views/Empik/UploadFile.vue' )
                //         }
                //     ]
                // },
                // {
                //     path: 'magazyn/raport',
                //     name: 'warehouse-report-list',
                //     component: () =>
                //         import ( './views/Warehouse/ReportList.vue' ),
                //     meta: {
                //         name: 'Raport'
                //     }
                // },
                // {
                //     path: 'magazyn/pracownicy',
                //     name: 'warehouse-workers-list',
                //     component: () =>
                //         import ( './views/Warehouse/WorkersList.vue' ),
                //     meta: {
                //         name: 'Pracownicy'
                //     }
                // },
                // {
                //     path: 'magazyn/dokumenty',
                //     name: 'warehouse-documents-list',
                //     component: () =>
                //         import ( './views/Warehouse/DocumentsList.vue' ),
                //     meta: {
                //         name: 'Dokumenty'
                //     }
                // },
                // {
                //     path: 'magazyn/wgraj-pliki',
                //     name: 'warehouse-upload',
                //     component: () =>
                //         import ( './views/Warehouse/UploadFileZS.vue' ),
                //     meta: {
                //         name: 'Dokumenty'
                //     }
                // },

                // {
                //     path: 'tablet',
                //     name: 'post-tablet-list',
                //     component: () =>
                //         import ( './views/POS/Tablet/List.vue' ),
                //     meta: {
                //         name: 'Tablet'
                //     }
                // },

                {
                    path: 'ustawienia/uzytkownicy',
                    name: 'users',
                    component: () =>
                        import ( './views/Users/UsersList.vue' ),
                    meta: {
                        name: 'Użytkownicy'
                    }
                },
                {
                    path: 'ustawienia/uzytkownicy/dodaj',
                    name: 'users-add',
                    component: () =>
                        import ( './views/Users/UsersAdd.vue' ),
                    meta: {
                        name: 'Użytkownicy'
                    }
                },
                {
                    path: 'ustawienia/uzytkownicy/:id',
                    name: 'users-details',
                    component: () =>
                        import ( './views/Users/UsersDetails.vue' ),
                    meta: {
                        name: 'Użytkownicy'
                    }
                }
            ]
        },
        // {
        //     path: '/pl/neonail/faq/',
        //     name: 'wrapper-editor',
        //     component: () =>
        //         import ( './views/WrapperEditor.vue' ),
        //     meta: {
        //         toDashboard: true
        //     },
        //     children: [ {
        //         path: ':id',
        //         name: 'plneonail-faq-editor',
        //         component: () =>
        //             import ( './views/ShopNNPL/NNPLFaqEditor.vue' )
        //     } ]
        // },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ( './views/Login.vue' ),
            meta: {
                public: true,
                onlyWhenLoggedOut: true
            }
        },
        {
            path: '/set/password',
            name: 'setPassword',
            component: () =>
                import ( './views/SetNewPassword.vue' )
        },
        {
            path: '/brak-uprawnien',
            name: 'NoPrivilege',
            component: () =>
                import ( './views/NoPrivilege.vue' ),
            meta: {
                public: true,
                onlyWhenLoggedOut: true
            }
        }
    ]
} )

router.beforeEach( ( to, from, next ) => {
    console.log( '---- next page ----' )
    console.log( to, from )
    console.log( to.query, from.query )
    console.log( to.path, from.path )
    console.log( to.path.includes( from.path ) )

    const isPublic = to.matched.some( record => record.meta.public )
    const onlyWhenLoggedOut = to.matched.some(
        record => record.meta.onlyWhenLoggedOut
    )
    const loggedIn = !!TokenService.getToken()

    if ( !isPublic && !loggedIn ) {
        return next( {
            path: '/login',
            query: { redirect: to.fullPath }
        } )
    }

    const jwtToken = TokenService.getToken()
    if ( jwtToken ) {
        const base64Url = jwtToken.split( '.' )[ 1 ]
        const base64 = base64Url.replace( '-', '+' ).replace( '_', '/' )
        const user = JSON.parse( window.atob( base64 ) )

        if (
            loggedIn &&
            to.name !== 'setPassword' &&
            store.getters[ 'users/active' ] === 0 &&
            user.active !== 1
        ) {
            return next( { name: 'setPassword' } )
        }
    }

    if ( loggedIn && onlyWhenLoggedOut ) {
        return next( '/dashboard' )
    }

    // if ( to.path.includes( from.path ) ) {
    //   const query = Object.assign( { replace: true }, from.query )
    //   console.log( query )
    //   next( {
    //     path: to.path,
    //     query: query
    //   } )
    // } else {
    next()
        // }
} )

export default router
